(() => {
/**
 * This file is just the entry point for the JS compiler. No actual scripts 
 * should be defined here. It is basically just a loader for the files below.
 */ document.addEventListener("DOMContentLoaded", ()=>{
    const actionHandlers = {
        jumpforward: $7bcaecb420633b0a$var$handleJumpForward,
        rewind: $7bcaecb420633b0a$var$handleRewind
    };
    document.querySelector(".j6csq-decision-tool").addEventListener("click", (event)=>{
        const button = event.target.closest(".j6csq-decision-tool-element-button");
        if (!button) return;
        const action = button.dataset.action;
        const target = button.dataset.actionTarget;
        if (action === "jumpforward") {
            const fromSlide = button.closest(".j6csq-decision-tool-slide");
            const isValid = $7bcaecb420633b0a$var$validateSlide(fromSlide);
            if (!isValid) return; // Stop if validation fails
        }
        actionHandlers[action]?.(button, target);
    });
});
function $7bcaecb420633b0a$var$handleJumpForward(button, target) {
    const targetSlide = document.getElementById(target);
    if (!targetSlide) {
        console.error(`Slide not found: ${target}`);
        alert("Error: Slide not found");
        return;
    }
    const fromSlide = button.closest(".j6csq-decision-tool-slide");
    if (fromSlide) {
        // Remove "chosen path" class from all buttons on the fromSlide
        fromSlide.querySelectorAll(".j6csq-decision-tool-element-button-chosenpath").forEach((btn)=>{
            btn.classList.remove("j6csq-decision-tool-element-button-chosenpath");
        });
        // Now add it to the button that was clicked
        button.classList.add("j6csq-decision-tool-element-button-chosenpath");
        // Calculate the button's horizontal center relative to the slide
        const buttonRect = button.getBoundingClientRect();
        const slideRect = fromSlide.getBoundingClientRect();
        const buttonCenter = buttonRect.left + buttonRect.width / 2 - slideRect.left;
        // Add the completed class which renders as a dashed vertical line, and dynamically set the background position
        fromSlide.classList.add("j6csq-decision-tool-slide-completed");
        fromSlide.style.backgroundPosition = `${buttonCenter}px bottom`;
        // Loop over all slides which come after the fromSlide in the DOM
        let current = fromSlide.nextElementSibling;
        while(current){
            // restores content and resets form inputs
            $7bcaecb420633b0a$var$resetSlide(current);
            // Hide the slide
            current.classList.remove("visible", "j6csq-decision-tool-slide-completed");
            current.setAttribute("aria-hidden", "true");
            current = current.nextElementSibling;
        }
    }
    // Interpolate input values into text elements on target slide, i.e. {$firstname} gets replaced with the value of the input with id "firstname"
    targetSlide.querySelectorAll(".j6csq-decision-tool-has-interpolated-text").forEach((element)=>{
        element.innerHTML = element.textContent.replace(/{\$([^}]+)}/g, (_, inputId)=>{
            const inputValue = document.getElementById(inputId)?.value || "";
            const escapedValue = $7bcaecb420633b0a$var$escapeHtml(inputValue);
            return escapedValue;
        });
    });
    // Activate the target slide
    targetSlide.setAttribute("aria-hidden", "false");
    targetSlide.classList.add("visible");
    targetSlide.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
    targetSlide.querySelector("h2")?.focus();
    document.getElementById("live-announcements").textContent = `Now viewing slide: ${targetSlide.querySelector("h2")?.textContent || "Slide"}`;
    document.dispatchEvent(new CustomEvent("slideActivated", {
        detail: {
            slideId: targetSlide.id
        }
    }));
}
function $7bcaecb420633b0a$var$escapeHtml(unsafe) {
    const div = document.createElement("div");
    div.textContent = unsafe;
    return div.innerHTML.replace(/"/g, "&quot;");
}
function $7bcaecb420633b0a$var$handleRewind(button, target) {
    const targetSlide = document.getElementById(target);
    if (!targetSlide) {
        console.error(`Slide not found: ${target}`);
        alert("Error: Slide not found");
        return;
    }
    const fromSlide = button.closest(".j6csq-decision-tool-slide");
    // Remove chosen path button class on rewind
    fromSlide.querySelectorAll(".j6csq-decision-tool-element-button-chosenpath").forEach((btn)=>{
        btn.classList.remove("j6csq-decision-tool-element-button-chosenpath");
    });
    // Reset and hide all slides after the target slide
    let current = fromSlide;
    while(current && current !== targetSlide){
        // restores content and resets form inputs
        $7bcaecb420633b0a$var$resetSlide(current);
        // Hide the slide
        current.classList.remove("visible", "j6csq-decision-tool-slide-completed");
        current.setAttribute("aria-hidden", "true");
        current = current.previousElementSibling;
    }
    // Ensure the target slide itself is reset
    targetSlide.classList.remove("j6csq-decision-tool-slide-completed");
    const form = targetSlide.querySelector("form");
    if (form) form.reset();
    // Activate the target slide
    document.querySelectorAll(".j6csq-decision-tool-slide").forEach((slide)=>{
        const isVisible = slide.classList.contains("visible") || slide === targetSlide;
        slide.setAttribute("aria-hidden", isVisible ? "false" : "true");
        slide.classList.toggle("visible", isVisible);
    });
    targetSlide.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
    targetSlide.querySelector("h2")?.focus();
    document.getElementById("live-announcements").textContent = `Now viewing slide: ${targetSlide.querySelector("h2")?.textContent || "Slide"}`;
    document.dispatchEvent(new CustomEvent("slideActivated", {
        detail: {
            slideId: targetSlide.id
        }
    }));
}
function $7bcaecb420633b0a$var$resetSlide(slide) {
    // Reset the form inputs to their initial values
    const form = slide.querySelector("form");
    if (form) form.reset();
    // Restore original text on interpolated elements
    slide.querySelectorAll(".j6csq-decision-tool-has-interpolated-text").forEach((element)=>{
        element.innerHTML = element.getAttribute("data-original-text");
    });
    // Remove error messages and classes
    slide.querySelectorAll(".j6csq-decision-tool-error-message").forEach((error)=>{
        error.hidden = true;
        error.textContent = "";
    });
    slide.querySelectorAll(".j6csq-decision-tool-has-error").forEach((element)=>{
        element.classList.remove("j6csq-decision-tool-has-error");
    });
    // Remove the completed class which renders as a dashed vertical line
    slide.classList.remove("j6csq-decision-tool-slide-completed");
    slide.style.backgroundPosition = "0 bottom";
}
function $7bcaecb420633b0a$var$validateSlide(slide) {
    let isValid = true;
    let firstInvalidElement = null;
    // Reset previous error messages and remove the error class
    slide.querySelectorAll(".j6csq-decision-tool-error-message").forEach((error)=>{
        error.hidden = true;
        error.textContent = "";
    });
    slide.querySelectorAll(".j6csq-decision-tool-has-error").forEach((element)=>{
        element.classList.remove("j6csq-decision-tool-has-error");
    });
    // Validate required inputs and textareas
    slide.querySelectorAll("input[data-j6csq-required], textarea[data-j6csq-required]").forEach((input)=>{
        if (!input.value.trim()) {
            isValid = false;
            if (!firstInvalidElement) firstInvalidElement = input; // Record first invalid element
            const errorId = input.getAttribute("aria-describedby");
            const error = document.getElementById(errorId);
            if (error) {
                error.hidden = false;
                error.textContent = "This field is required.";
            }
            input.classList.add("j6csq-decision-tool-has-error"); // Add error class
        }
    });
    // Validate required fieldsets (checkboxes and radios)
    slide.querySelectorAll("fieldset[data-j6csq-required]").forEach((fieldset)=>{
        const checkboxes = fieldset.querySelectorAll('input[type="checkbox"]');
        const radios = fieldset.querySelectorAll('input[type="radio"]');
        const isCheckboxValid = checkboxes.length && Array.from(checkboxes).some((checkbox)=>checkbox.checked);
        const isRadioValid = radios.length && Array.from(radios).some((radio)=>radio.checked);
        if (!checkboxes.length && !radios.length || !isCheckboxValid && !isRadioValid) {
            isValid = false;
            if (!firstInvalidElement) firstInvalidElement = fieldset; // Record first invalid element
            const errorId = fieldset.getAttribute("aria-describedby");
            const error = document.getElementById(errorId);
            if (error) {
                error.hidden = false;
                error.textContent = "Please select at least one option.";
            }
            fieldset.classList.add("j6csq-decision-tool-has-error"); // Add error class
        }
    });
    // Scroll to the top of the slide if validation fails
    if (!isValid && firstInvalidElement) {
        slide.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
        // Optionally focus the first invalid element
        firstInvalidElement.focus();
    }
    return isValid;
}


/* 
 * This demonstrates how an external script can listen for slideActivated events on a single, specific
 * decision tool and react to them. The point of having this in a separate file is to show how the main 
 * decision-tool.js file might be bundled with the CDP or some other distribution of that nature that is
 * installed across multiple sites, with a standalone script like this appearing on individual sites to 
 * implement journey-specific logic.
 */ document.addEventListener("DOMContentLoaded", function() {
    // Wait for slides to be activated
    document.addEventListener("slideActivated", function(event) {
        const slideId = event.detail.slideId;
        switch(slideId){
            case "s4a":
                // Hide the "Other" text input on slide 4a on slide activation
                document.querySelector("#reasonsfordecisionother").closest(".j6csq-decision-tool-element-single_line_text_input").style.display = "none";
                // Populate the summary page focus field based on the user's selection on the previous slide
                document.getElementById("j6csq-financialdt-summary-focus").innerHTML = document.getElementById("focuspay").innerHTML;
                break;
            case "s4b":
                // Populate the summary page focus field based on the user's selection on the previous slide
                document.getElementById("j6csq-financialdt-summary-focus").innerHTML = document.getElementById("focusquit").innerHTML;
                // Hide the "Other" text input on slide 4b on slide activation
                document.querySelector("#motivationfordecisionothertext").closest(".j6csq-decision-tool-element-single_line_text_input").style.display = "none";
                break;
            // Final summary screen
            case "s22b":
                // Get the checked status of the three checkboxes
                const checkbox1 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Impact on your Income + Expenses"]').checked;
                const checkbox2 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Effect on your Savings + Retirement"]').checked;
                const checkbox3 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Balancing your Work + Life Responsibilities"]').checked;
                // show and hide result subsections based on the checkboxes
                $3677159a02a3422e$var$j6csqShowHideSectionsBySelector(".j6csq-financialdt-summary-results-income", checkbox1);
                $3677159a02a3422e$var$j6csqShowHideSectionsBySelector(".j6csq-financialdt-summary-results-savings", checkbox2);
                $3677159a02a3422e$var$j6csqShowHideSectionsBySelector(".j6csq-financialdt-summary-results-worklife", checkbox3);
                // show and hide the Actions to Consider subsections based on the checkboxes
                $3677159a02a3422e$var$j6csqShowHideSectionsBySelector("#j6csq-financialdt-summary-actions-to-consider-income", checkbox1);
                $3677159a02a3422e$var$j6csqShowHideSectionsBySelector("#j6csq-financialdt-summary-actions-to-consider-savings", checkbox2);
                $3677159a02a3422e$var$j6csqShowHideSectionsBySelector("#j6csq-financialdt-summary-actions-to-consider-worklife", checkbox3);
                // Set the three "Actions to Consider" UL lists to empty for starters
                document.querySelector("#j6csq-financialdt-summary-actions-to-consider-income ul").innerHTML = "";
                document.querySelector("#j6csq-financialdt-summary-actions-to-consider-savings ul").innerHTML = "";
                document.querySelector("#j6csq-financialdt-summary-actions-to-consider-worklife ul").innerHTML = "";
                // 1 of 3: Populate the "Actions to Consider" list for Income
                if (checkbox1) {
                    let thingsToConsider = [];
                    // Get value of ids incomeslider1 through incomeslider7.  
                    // For each one whose value is 1, get the corresponding label and add it to the array
                    for(let i = 1; i <= 7; i++){
                        const slider = document.getElementById(`incomeslider${i}`);
                        if (slider.value === "1") thingsToConsider.push(document.querySelector(`label[for="incomeslider${i}"]`).textContent);
                    }
                    thingsToConsider.push("Another thing to keep in mind: If you retire and start getting Social Security benefits before your full retirement age, there's a limit to how much you can earn if you decide to go back to work. If you earn more than the limit ($21,240 in 2023), you'll have penalties deducted from your Social Security payments.");
                    // populate the ul list
                    const ul = document.querySelector("#j6csq-financialdt-summary-actions-to-consider-income ul");
                    if (thingsToConsider.length) thingsToConsider.forEach(function(item) {
                        const li = document.createElement("li");
                        li.textContent = item.replace(" (Required)", "");
                        ul.appendChild(li);
                    });
                }
                // 2 of 3: Populate the "Actions to Consider" list for Savings
                if (checkbox2) {
                    let thingsToConsider = [];
                    thingsToConsider.push("Talk to a financial planner");
                    thingsToConsider.push("Higher income translates to a bigger Social Security benefit when you retire, so if you quit your full-time job, you should figure out what that will mean to your wallet. Your Social Security benefit is based on the average amount of money you made each month during your 35 highest-earning years, adjusted for inflation. If you\u2019re one of the 40% of people over 65 who get at least half of their income from Social Security, then a lower benefit means less money later in life.");
                    // populate the ul list
                    const ul = document.querySelector("#j6csq-financialdt-summary-actions-to-consider-savings ul");
                    if (thingsToConsider.length) thingsToConsider.forEach(function(item) {
                        const li = document.createElement("li");
                        li.textContent = item.replace(" (Required)", "");
                        ul.appendChild(li);
                    });
                }
                // 3 of 3: Populate the "Actions to Consider" list for Work/Life Balance
                if (checkbox3) {
                    let thingsToConsider = [];
                    // Get a list of all checkboxes with the name "worklifecheck" and add the checked ones to the array
                    document.querySelectorAll('input[name="worklifecheck"]').forEach(function(checkbox) {
                        if (checkbox.checked) thingsToConsider.push(checkbox.value);
                    });
                    thingsToConsider.push('You may want to take a look at this article from AARP by Dr. Barry Jacobs: <a href="https://www.aarp.org/caregiving/basics/info-2024/embrace-new-life-after-caregiving.html" target="_blank" rel="noopener noreferrer">How Family Caregiving Can Alter Dreams and Goals Deferred</a>.');
                    // populate the ul list
                    const ul = document.querySelector("#j6csq-financialdt-summary-actions-to-consider-worklife ul");
                    if (thingsToConsider.length) thingsToConsider.forEach(function(item) {
                        const li = document.createElement("li");
                        if (item.includes("<a ")) // If the item contains an anchor tag, set the innerHTML
                        li.innerHTML = item;
                        else // Otherwise, set the textContent
                        li.textContent = item.replace(" (Required)", "");
                        ul.appendChild(li);
                    });
                }
                break;
        }
    });
    // Here we listen for checkbox changes on slide 8b and react accordingly
    document.querySelectorAll('#financialdt input[name="s8bcheckboxes"]').forEach(function(checkbox) {
        checkbox.addEventListener("change", function(event) {
            // Get the checked status of the three checkboxes
            const checkbox1 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Impact on your Income + Expenses"]').checked;
            const checkbox2 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Effect on your Savings + Retirement"]').checked;
            const checkbox3 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Balancing your Work + Life Responsibilities"]').checked;
            // Set the start button target based on the checkboxes
            const buttonStart = document.getElementById("bmultipathstart");
            if (checkbox1) {
                buttonStart.setAttribute("data-action", "jumpforward");
                buttonStart.setAttribute("data-action-target", "s9b"); // jump to start of path 1
                buttonStart.disabled = false;
            } else if (checkbox2) {
                buttonStart.setAttribute("data-action", "jumpforward");
                buttonStart.setAttribute("data-action-target", "s13b"); // jump to start of path 2
                buttonStart.disabled = false;
            } else if (checkbox3) {
                buttonStart.setAttribute("data-action", "jumpforward"); // jump to start of path 3
                buttonStart.setAttribute("data-action-target", "s17b");
                buttonStart.disabled = false;
            } else {
                buttonStart.setAttribute("data-action", "noaction"); // nothing selected so button is disabled
                buttonStart.setAttribute("data-action-target", "");
                buttonStart.disabled = true;
            }
            const buttonPath1End = document.getElementById("bmultipath1end");
            if (checkbox2) {
                buttonPath1End.setAttribute("data-action", "jumpforward");
                buttonPath1End.setAttribute("data-action-target", "s13b"); // jump to start of path 2
            } else if (checkbox3) {
                buttonPath1End.setAttribute("data-action", "jumpforward"); // jump to start of path 3
                buttonPath1End.setAttribute("data-action-target", "s17b");
            } else {
                buttonPath1End.setAttribute("data-action", "jumpforward"); // nothing selected so button is disabled
                buttonPath1End.setAttribute("data-action-target", "s22b"); // proceed to final summary
            }
            const buttonPath2End = document.getElementById("bmultipath2end");
            if (checkbox3) {
                buttonPath2End.setAttribute("data-action", "jumpforward"); // jump to start of path 3
                buttonPath2End.setAttribute("data-action-target", "s17b");
            } else {
                buttonPath2End.setAttribute("data-action", "jumpforward"); // nothing selected so button is disabled
                buttonPath2End.setAttribute("data-action-target", "s22b"); // proceed to final summary
            }
        // We don't need to specify buttonPath3End as it always points to s22b
        });
    });
    // Listen for the "Other" checkbox on slide 4a to change and react accordingly
    document.querySelectorAll('#financialdt input[name="reasonsfordecision"][value="Other"]').forEach(function(checkbox) {
        checkbox.addEventListener("change", function(event) {
            // Get the checked status of the "Other" checkbox
            const checkboxOther = event.target.checked;
            // Show or hide the "Other" text input based on the checkbox status
            document.querySelector("#reasonsfordecisionother").closest(".j6csq-decision-tool-element-single_line_text_input").style.display = checkboxOther ? "block" : "none";
        });
    });
    // Listen for the "Other" checkbox on slide 4b to change and react accordingly
    document.querySelectorAll('#financialdt input[name="motivationfordecision"][value="Other"]').forEach(function(checkbox) {
        checkbox.addEventListener("change", function(event) {
            // Get the checked status of the "Other" checkbox
            const checkboxOther = event.target.checked;
            // Show or hide the "Other" text input based on the checkbox status
            document.querySelector("#motivationfordecisionothertext").closest(".j6csq-decision-tool-element-single_line_text_input").style.display = checkboxOther ? "block" : "none";
        });
    });
});
function $3677159a02a3422e$var$j6csqShowHideSectionsBySelector(thisSelector, visible) {
    document.querySelectorAll(thisSelector).forEach(function(div) {
        div.style.display = visible ? "block" : "none";
    });
}


jQuery(document).on("gform_post_render", function() {
    jQuery("#field_6_14").click(function() {
        if (jQuery("#choice_6_14_1").is(":checked") && jQuery("#choice_6_14_2").is(":checked") && jQuery("#choice_6_14_3").is(":checked")) {
            jQuery("#field_6_14 .alertmessage").remove();
            jQuery("#field_6_14 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_6_14 .alertmessage").remove();
            jQuery("#field_6_14 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 these are all a part of bathing.</div>");
        }
    });
    jQuery("#field_6_14").click(function() {
        if (!jQuery("#choice_6_14_1").is(":checked") && !jQuery("#choice_6_14_2").is(":checked") && !jQuery("#choice_6_14_3").is(":checked")) jQuery("#field_6_14 .alertmessage").remove();
    });
    jQuery("#field_6_11").click(function() {
        if (jQuery("#choice_6_11_1").is(":checked") && jQuery("#choice_6_11_2").is(":checked") && jQuery("#choice_6_11_3").is(":checked") && jQuery("#choice_6_11_4").is(":checked") && jQuery("#choice_6_11_5").is(":checked")) {
            jQuery("#field_6_11 .alertmessage").remove();
            jQuery("#field_6_11 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_6_11 .alertmessage").remove();
            jQuery("#field_6_11 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking! All these questions might be helpful.</div>");
        }
    });
    jQuery("#field_6_11").click(function() {
        if (!jQuery("#choice_6_11_1").is(":checked") && !jQuery("#choice_6_11_2").is(":checked") && !jQuery("#choice_6_11_3").is(":checked") && !jQuery("#choice_6_11_4").is(":checked") && !jQuery("#choice_6_11_5").is(":checked")) jQuery("#field_6_11 .alertmessage").remove();
    });
    jQuery("#field_6_12").click(function() {
        if (jQuery("#choice_6_12_1").is(":checked") && jQuery("#choice_6_12_2").is(":checked") && !jQuery("#choice_6_12_3").is(":checked") && !jQuery("#choice_6_12_4").is(":checked")) {
            jQuery("#field_6_12 .alertmessage").remove();
            jQuery("#field_6_12 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_6_12 .alertmessage").remove();
            jQuery("#field_6_12 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking! There is one more example of Raina supporting Lou.</div>");
        }
    });
    jQuery("#field_6_12").click(function() {
        if (!jQuery("#choice_6_12_1").is(":checked") && !jQuery("#choice_6_12_2").is(":checked") && !jQuery("#choice_6_12_3").is(":checked") && !jQuery("#choice_6_12_4").is(":checked")) jQuery("#field_6_12 .alertmessage").remove();
    });
    jQuery("#field_6_12").click(function() {
        if (jQuery("#choice_6_12_3").is(":checked")) {
            jQuery("#field_6_12 .alertmessage").remove();
            jQuery("#field_6_12 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_12_4").is(":checked")) {
            jQuery("#field_6_12 .alertmessage").remove();
            jQuery("#field_6_12 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_12_4").is(":checked") && jQuery("#choice_6_12_3").is(":checked")) {
            jQuery("#field_6_12 .alertmessage").remove();
            jQuery("#field_6_12 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_6_12").click(function() {
        if (jQuery("#choice_6_12_3").is(":checked")) {
            jQuery(".alertmessage.gchoice_6_12_3").remove();
            jQuery(".gchoice_6_12_3 ").after("<div class='alertmessage insidecheckbox gchoice_6_12_3'>If a person is angry, it might be best to let them reset before trying to help them again.</div>");
        } else jQuery(".alertmessage.gchoice_6_12_3").remove();
    });
    jQuery("#field_6_12").click(function() {
        if (jQuery("#choice_6_12_4").is(":checked")) {
            jQuery(".alertmessage.gchoice_6_12_4").remove();
            jQuery(".gchoice_6_12_4 ").after("<div class='alertmessage insidecheckbox gchoice_6_12_4'>Having dementia does not automatically make a person not want to shower. Having dementia can cause a person to think and act differently because they are confused about what is happening, or having trouble explaining what they want or don\u2019t want.</div>");
        } else jQuery(".alertmessage.gchoice_6_12_4").remove();
    });
    jQuery("#field_6_13").click(function() {
        if (jQuery("#choice_6_13_1").is(":checked") && jQuery("#choice_6_13_2").is(":checked") && jQuery("#choice_6_13_3").is(":checked") && !jQuery("#choice_6_13_4").is(":checked") && !jQuery("#choice_6_13_5").is(":checked") && !jQuery("#choice_6_13_6").is(":checked")) {
            jQuery("#field_6_13 .alertmessage").remove();
            jQuery("#field_6_13 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_6_13 .alertmessage").remove();
            jQuery("#field_6_13 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking! There are more examples of honoring your loved one\u2019s bathing preferences.</div>");
        }
    });
    jQuery("#field_6_13").click(function() {
        if (!jQuery("#choice_6_13_1").is(":checked") && !jQuery("#choice_6_13_2").is(":checked") && !jQuery("#choice_6_13_3").is(":checked") && !jQuery("#choice_6_13_4").is(":checked") && !jQuery("#choice_6_13_5").is(":checked") && !jQuery("#choice_6_13_6").is(":checked")) jQuery("#field_6_13 .alertmessage").remove();
    });
    jQuery("#field_6_13").click(function() {
        if (jQuery("#choice_6_13_4").is(":checked")) {
            jQuery("#field_6_13 .alertmessage").remove();
            jQuery("#field_6_13 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_13_5").is(":checked")) {
            jQuery("#field_6_13 .alertmessage").remove();
            jQuery("#field_6_13 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_13_6").is(":checked")) {
            jQuery("#field_6_13 .alertmessage").remove();
            jQuery("#field_6_13 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_13_4").is(":checked") && jQuery("#choice_6_13_5").is(":checked") && !jQuery("#choice_6_13_6").is(":checked")) {
            jQuery("#field_6_13 .alertmessage").remove();
            jQuery("#field_6_13 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (!jQuery("#choice_6_13_4").is(":checked") && jQuery("#choice_6_13_5").is(":checked") && jQuery("#choice_6_13_6").is(":checked")) {
            jQuery("#field_6_13 .alertmessage").remove();
            jQuery("#field_6_13 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_13_4").is(":checked") && !jQuery("#choice_6_13_5").is(":checked") && jQuery("#choice_6_13_6").is(":checked")) {
            jQuery("#field_6_13 .alertmessage").remove();
            jQuery("#field_6_13 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_13_4").is(":checked") && jQuery("#choice_6_13_5").is(":checked") && jQuery("#choice_6_13_6").is(":checked")) {
            jQuery("#field_6_13 .alertmessage").remove();
            jQuery("#field_6_13 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_6_13").click(function() {
        if (jQuery("#choice_6_13_4").is(":checked")) {
            jQuery(".alertmessage.gchoice_6_13_4").remove();
            jQuery(".gchoice_6_13_4").after("<div class='alertmessage insidecheckbox gchoice_6_13_4'>Arya\u2019s care partner is not honoring Arya\u2019s preference of showering tomorrow.</div>");
        } else jQuery(".alertmessage.gchoice_6_13_4").remove();
    });
    jQuery("#field_6_13").click(function() {
        if (jQuery("#choice_6_13_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_6_13_5").remove();
            jQuery(".gchoice_6_13_5").after("<div class='alertmessage insidecheckbox gchoice_6_13_5'>Jacob\u2019s care partner is honoring her preferences for music, not Jacob\u2019s.</div>");
        } else jQuery(".alertmessage.gchoice_6_13_5").remove();
    });
    jQuery("#field_6_13").click(function() {
        if (jQuery("#choice_6_13_6").is(":checked")) {
            jQuery(".alertmessage.gchoice_6_13_6").remove();
            jQuery(".gchoice_6_13_6").after("<div class='alertmessage insidecheckbox gchoice_6_13_6'>Maeve\u2019s care partner is basing her actions on what is easier for her, not what Maeve wants.</div>");
        } else jQuery(".alertmessage.gchoice_6_13_6").remove();
    });
    jQuery("#field_6_15").click(function() {
        if (jQuery("#choice_6_15_1").is(":checked") && jQuery("#choice_6_15_2").is(":checked") && jQuery("#choice_6_15_3").is(":checked") && jQuery("#choice_6_15_4").is(":checked")) {
            jQuery("#field_6_15 .alertmessage").remove();
            jQuery("#field_6_15 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_6_15 .alertmessage").remove();
            jQuery("#field_6_15 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking! There are more examples of showing support for Alphie.</div>");
        }
    });
    jQuery("#field_6_15").click(function() {
        if (!jQuery("#choice_6_15_1").is(":checked") && !jQuery("#choice_6_15_2").is(":checked") && !jQuery("#choice_6_15_3").is(":checked") && !jQuery("#choice_6_15_4").is(":checked") && !jQuery("#choice_6_15_5").is(":checked") && !jQuery("#choice_6_15_6").is(":checked")) jQuery("#field_6_15 .alertmessage").remove();
    });
    jQuery("#field_6_15").click(function() {
        if (jQuery("#choice_6_15_5").is(":checked")) {
            jQuery("#field_6_15 .alertmessage").remove();
            jQuery("#field_6_15 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_15_6").is(":checked")) {
            jQuery("#field_6_15 .alertmessage").remove();
            jQuery("#field_6_15 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_15_5").is(":checked") && jQuery("#choice_6_15_6").is(":checked")) {
            jQuery("#field_6_15 .alertmessage").remove();
            jQuery("#field_6_15 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_6_15").click(function() {
        if (jQuery("#choice_6_15_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_6_15_5").remove();
            jQuery(".gchoice_6_15_5 ").after("<div class='alertmessage insidecheckbox gchoice_6_15_5'>Tom supports Alphie to do what he can, and he helps Alphie with the things he has difficulty doing.</div>");
        } else jQuery(".alertmessage.gchoice_6_15_5").remove();
    });
    jQuery("#field_6_15").click(function() {
        if (jQuery("#choice_6_15_6").is(":checked")) {
            jQuery(".alertmessage.gchoice_6_15_6").remove();
            jQuery(".gchoice_6_15_6 ").after("<div class='alertmessage insidecheckbox gchoice_6_15_6'>Alphie needs verbal and cognitive support from Tom to do as much as he can, including reminders and a bathing environment that Tom prepares for him.</div>");
        } else jQuery(".alertmessage.gchoice_6_15_6").remove();
    });
    jQuery("#field_6_16").click(function() {
        if (jQuery("#choice_6_16_1").is(":checked") && jQuery("#choice_6_16_2").is(":checked") && !jQuery("#choice_6_16_3").is(":checked") && !jQuery("#choice_6_16_4").is(":checked")) {
            jQuery("#field_6_16 .alertmessage").remove();
            jQuery("#field_6_16 .ginput_container_checkbox").after("<div class='alertmessage success'>Well done! You\u2019ve completed the lesson.</div>");
        } else {
            jQuery("#field_6_16 .alertmessage").remove();
            jQuery("#field_6_16 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking! There is one more example of Layla supporting Vera.</div>");
        }
    });
    jQuery("#field_6_16").click(function() {
        if (!jQuery("#choice_6_16_1").is(":checked") && !jQuery("#choice_6_16_2").is(":checked") && !jQuery("#choice_6_16_3").is(":checked") && !jQuery("#choice_6_16_4").is(":checked")) jQuery("#field_6_16 .alertmessage").remove();
    });
    jQuery("#field_6_16").click(function() {
        if (jQuery("#choice_6_16_3").is(":checked")) {
            jQuery("#field_6_16 .alertmessage").remove();
            jQuery("#field_6_16 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_16_4").is(":checked")) {
            jQuery("#field_6_16 .alertmessage").remove();
            jQuery("#field_6_16 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_6_16_3").is(":checked") && jQuery("#choice_6_16_4").is(":checked")) {
            jQuery("#field_6_16 .alertmessage").remove();
            jQuery("#field_6_16 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_6_16").click(function() {
        if (jQuery("#choice_6_16_3").is(":checked")) {
            jQuery(".alertmessage.gchoice_6_16_3").remove();
            jQuery(".gchoice_6_16_3 ").after("<div class='alertmessage insidecheckbox gchoice_6_16_3'>Doing nothing is not giving Vera the support she needs. Vera might be difficult, but Layla needs to try to understand what might be going on with Vera to offer proper support.</div>");
        } else jQuery(".alertmessage.gchoice_6_16_3").remove();
    });
    jQuery("#field_6_16").click(function() {
        if (jQuery("#choice_6_16_4").is(":checked")) {
            jQuery(".alertmessage.gchoice_6_16_4").remove();
            jQuery(".gchoice_6_16_4 ").after("<div class='alertmessage insidecheckbox gchoice_6_16_4'>It is important to support your loved one\u2019s choices and not order them to shower. Discuss bathing concerns that may be affecting your loved one\u2019s physical health with their provider.</div>");
        } else jQuery(".alertmessage.gchoice_6_16_4").remove();
    });
    /* Eating Support*/ jQuery("#field_2_11").click(function() {
        if (jQuery("#choice_2_11_4").is(":checked") && jQuery("#choice_2_11_2").is(":checked") && jQuery("#choice_2_11_3").is(":checked")) {
            jQuery("#field_2_11 .alertmessage").remove();
            jQuery("#field_2_11 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_2_11 .alertmessage").remove();
            jQuery("#field_2_11 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more important eating concepts.</div>");
        }
        if (jQuery("#choice_2_11_1").is(":checked")) {
            jQuery("#field_2_11 .alertmessage").remove();
            jQuery("#field_2_11 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery("#choice_2_11_1").is(":checked") && !jQuery("#choice_2_11_2").is(":checked") && !jQuery("#choice_2_11_3").is(":checked") && !jQuery("#choice_2_11_4").is(":checked")) jQuery("#field_2_11 .alertmessage").remove();
    });
    jQuery("#field_2_11").click(function() {
        if (jQuery("#choice_2_11_1").is(":checked")) {
            jQuery(".alertmessage.gchoice_2_11_1").remove();
            jQuery(".gchoice_2_11_1 ").after("<div class='alertmessage insidecheckbox gchoice_2_11_1'> When we are supporting a person with eating, we need to really try to ensure a person is eating what they want and in the way they want. This looks different for each person, but we can try our best to make it happen.</div>");
        }
    });
    jQuery("#field_2_12").click(function() {
        if (jQuery("#choice_2_12_1").is(":checked") && jQuery("#choice_2_12_2").is(":checked") && jQuery("#choice_2_12_3").is(":checked")) {
            jQuery("#field_2_12 .alertmessage").remove();
            jQuery("#field_2_12 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_2_12 .alertmessage").remove();
            jQuery("#field_2_12 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more signs your loved one might need to be reminded to drink water.</div>");
        }
        if (jQuery("#choice_2_12_4").is(":checked")) {
            jQuery("#field_2_12 .alertmessage").remove();
            jQuery("#field_2_12 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery("#choice_2_12_1").is(":checked") && !jQuery("#choice_2_12_2").is(":checked") && !jQuery("#choice_2_12_3").is(":checked") && !jQuery("#choice_2_12_4").is(":checked")) jQuery("#field_2_12 .alertmessage").remove();
    });
    jQuery("#field_2_12").click(function() {
        if (jQuery("#choice_2_12_4").is(":checked")) {
            jQuery(".alertmessage.gchoice_2_12_4").remove();
            jQuery(".gchoice_2_12_4 ").after("<div class='alertmessage insidecheckbox gchoice_2_12_4'> There is no evidence that dementia causes people to not like drinking water. It is usually due to other things, like forgetting to drink water. Tammy is showing several signs that she might need more support in remembering to drink more water.</div>");
        }
    });
    jQuery("#field_2_13").click(function() {
        if (jQuery("#choice_2_13_1").is(":checked") && jQuery("#choice_2_13_2").is(":checked") && jQuery("#choice_2_13_3").is(":checked") && jQuery("#choice_2_13_4").is(":checked")) {
            jQuery("#field_2_13 .alertmessage").remove();
            jQuery("#field_2_13 .ginput_container_checkbox").after("<div class='alertmessage success'>Well done! You\u2019ve completed the lesson.</div>");
        } else {
            jQuery("#field_2_13 .alertmessage").remove();
            jQuery("#field_2_13 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more ways to ensure Danielle is involved.</div>");
        }
        if (!jQuery("#choice_2_13_1").is(":checked") && !jQuery("#choice_2_13_2").is(":checked") && !jQuery("#choice_2_13_3").is(":checked") && !jQuery("#choice_2_13_4").is(":checked")) jQuery("#field_2_13 .alertmessage").remove();
    });
    jQuery("#field_2_14").click(function() {
        if (jQuery("#choice_2_14_1").is(":checked") && jQuery("#choice_2_14_2").is(":checked") && jQuery("#choice_2_14_3").is(":checked") && jQuery("#choice_2_14_4").is(":checked")) {
            jQuery("#field_2_14 .alertmessage").remove();
            jQuery("#field_2_14 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_2_14 .alertmessage").remove();
            jQuery("#field_2_14 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 these are all a part of eating and drinking.</div>");
        }
        if (!jQuery("#choice_2_14_1").is(":checked") && !jQuery("#choice_2_14_2").is(":checked") && !jQuery("#choice_2_14_3").is(":checked") && !jQuery("#choice_2_14_4").is(":checked")) jQuery("#field_2_14 .alertmessage").remove();
    });
    jQuery("#field_2_8").click(function() {
        if (jQuery("#choice_2_8_0").is(":checked")) {
            jQuery("#field_2_8 .alertmessage").remove();
            jQuery(".alertmessage.gchoice_2_8_1").remove();
            jQuery("#field_2_8 .ginput_container_radio").after("<div class='alertmessage success'>Great job!</div>");
        }
    });
    jQuery("#field_2_8").click(function() {
        if (jQuery("#choice_2_8_1").is(":checked")) {
            jQuery("#field_2_8 .alertmessage").remove();
            jQuery("#field_2_8 .ginput_container_radio").after("<div class='alertmessage moreselection'>Your selection is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_2_8").click(function() {
        if (!jQuery("#choice_2_8_0").is(":checked") && jQuery("#choice_2_8_1").is(":checked")) {
            jQuery(".alertmessage.gchoice_2_8_1").remove();
            jQuery(".gchoice_2_8_1 ").after("<div class='alertmessage insidecheckbox gchoice_2_8_1'> Encouraging foods high in water content can help keep a person hydrated. </div>");
        } else jQuery(".alertmessage.gchoice_2_8_1").remove();
    });
    jQuery("#field_2_15").click(function() {
        if (jQuery("#choice_2_15_1").is(":checked") && jQuery("#choice_2_15_2").is(":checked") && jQuery("#choice_2_15_3").is(":checked")) {
            jQuery("#field_2_15 .alertmessage").remove();
            jQuery("#field_2_15 .ginput_container_checkbox").after("<div class='alertmessage success'>Well done! You\u2019ve completed the lesson.</div>");
        } else {
            jQuery("#field_2_15 .alertmessage").remove();
            jQuery("#field_2_15 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more examples of honoring your loved one\u2019s preferences or choices.</div>");
        }
        if (jQuery("#choice_2_15_4").is(":checked")) {
            jQuery("#field_2_15 .alertmessage").remove();
            jQuery("#field_2_15 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_2_15_5").is(":checked")) {
            jQuery("#field_2_15 .alertmessage").remove();
            jQuery("#field_2_15 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery("#choice_2_15_6").is(":checked")) {
            jQuery("#field_2_15 .alertmessage").remove();
            jQuery("#field_2_15 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery("#choice_2_15_1").is(":checked") && !jQuery("#choice_2_15_2").is(":checked") && !jQuery("#choice_2_15_3").is(":checked") && !jQuery("#choice_2_15_4").is(":checked") && !jQuery("#choice_2_15_5").is(":checked") && !jQuery("#choice_2_15_6").is(":checked")) jQuery("#field_2_15 .alertmessage").remove();
    });
    jQuery("#field_2_15").click(function() {
        if (jQuery("#choice_2_15_4").is(":checked")) {
            jQuery(".alertmessage.gchoice_2_15_4").remove();
            jQuery(".gchoice_2_15_4 ").after("<div class='alertmessage insidecheckbox gchoice_2_15_4'>It is wrong for Gary to assume that it does matter to Jose what he eats or that he does not want to be involved in choosing food. Gary is not trying to honor his preferences by not asking him.</div>");
        }
    });
    jQuery("#field_2_15").click(function() {
        if (jQuery("#choice_2_15_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_2_15_5").remove();
            jQuery(".gchoice_2_15_5 ").after("<div class='alertmessage insidecheckbox gchoice_2_15_5'>While Keke might have good intentions in trying to keep Mariah from dropping food on herself by making different food, she does not ask Mariah about this, and is not honoring Mariah\u2019s food preferences.</div>");
        }
    });
    jQuery("#field_2_15").click(function() {
        if (jQuery("#choice_2_15_6").is(":checked")) {
            jQuery(".alertmessage.gchoice_2_15_6").remove();
            jQuery(".gchoice_2_15_6 ").after("<div class='alertmessage insidecheckbox gchoice_2_15_6'>Anna also has good intentions in trying to help Christine eat, but she is not doing it in line with what Christine wants \u2013 it is important that Christine be able to choose the food she likes.</div>");
        }
    });
    /*Dressing Support*/ jQuery("#field_7_14").click(function() {
        if (jQuery("#choice_7_14_1").is(":checked") && jQuery("#choice_7_14_2").is(":checked") && jQuery("#choice_7_14_3").is(":checked") && jQuery("#choice_7_14_4").is(":checked") && jQuery("#choice_7_14_5").is(":checked")) {
            jQuery("#field_7_14 .alertmessage").remove();
            jQuery("#field_7_14 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_7_14 .alertmessage").remove();
            jQuery("#field_7_14 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 these are all a part of dressing.</div>");
        }
        if (!jQuery("#choice_7_14_1").is(":checked") && !jQuery("#choice_7_14_2").is(":checked") && !jQuery("#choice_7_14_3").is(":checked") && !jQuery("#choice_7_14_4").is(":checked") && !jQuery("#choice_7_14_5").is(":checked")) jQuery("#field_7_14 .alertmessage").remove();
    });
    jQuery("#field_7_11").click(function() {
        if (jQuery("#choice_7_11_1").is(":checked") && jQuery("#choice_7_11_2").is(":checked") && jQuery("#choice_7_11_3").is(":checked") && jQuery("#choice_7_11_4").is(":checked") && jQuery("#choice_7_11_5").is(":checked") && jQuery("#choice_7_11_6").is(":checked") && jQuery("#choice_7_11_7").is(":checked") && jQuery("#choice_7_11_8").is(":checked")) {
            jQuery("#field_7_11 .alertmessage").remove();
            jQuery("#field_7_11 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_7_11 .alertmessage").remove();
            jQuery("#field_7_11 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 more questions can help understand your loved one\u2019s preferences for dressing.</div>");
        }
        if (jQuery("#choice_7_11_9").is(":checked")) {
            jQuery("#field_7_11 .alertmessage").remove();
            jQuery("#field_7_11 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery("#choice_7_11_1").is(":checked") && !jQuery("#choice_7_11_2").is(":checked") && !jQuery("#choice_7_11_3").is(":checked") && !jQuery("#choice_7_11_4").is(":checked") && !jQuery("#choice_7_11_5").is(":checked") && !jQuery("#choice_7_11_6").is(":checked") && !jQuery("#choice_7_11_7").is(":checked") && !jQuery("#choice_7_11_8").is(":checked") && !jQuery("#choice_7_11_9").is(":checked")) jQuery("#field_7_11 .alertmessage").remove();
    });
    jQuery("#field_7_11").click(function() {
        if (jQuery("#choice_7_11_9").is(":checked")) {
            jQuery(".alertmessage.gchoice_7_11_9").remove();
            jQuery(".gchoice_7_11_9 ").after("<div class='alertmessage insidecheckbox gchoice_7_11_9'>While Keke might have good intentions in trying to keep Mariah from dropping food on herself by making different food, she does not ask Mariah about this, and is not honoring Mariah\u2019s food preferences.</div>");
        }
    });
    jQuery("#field_7_12").click(function() {
        if (jQuery("#choice_7_12_1").is(":checked") && jQuery("#choice_7_12_2").is(":checked") && jQuery("#choice_7_12_3").is(":checked")) {
            jQuery("#field_7_12 .alertmessage").remove();
            jQuery("#field_7_12 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_7_12 .alertmessage").remove();
            jQuery("#field_7_12 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more examples of offering choices.</div>");
        }
        if (jQuery("#choice_7_12_4").is(":checked") || jQuery("#choice_7_12_5").is(":checked")) {
            jQuery("#field_7_12 .alertmessage").remove();
            jQuery("#field_7_12 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery("#choice_7_12_1").is(":checked") && !jQuery("#choice_7_12_2").is(":checked") && !jQuery("#choice_7_12_3").is(":checked") && !jQuery("#choice_7_12_4").is(":checked") && !jQuery("#choice_7_12_5").is(":checked")) jQuery("#field_7_12 .alertmessage").remove();
    });
    jQuery("#field_7_12").click(function() {
        if (jQuery("#choice_7_12_4").is(":checked")) {
            jQuery(".alertmessage.gchoice_7_12_4").remove();
            jQuery(".gchoice_7_12_4 ").after("<div class='alertmessage insidecheckbox gchoice_7_12_4'>You are making the choice for the person. It\u2019s possible your loved one wants to wear certain clothes regardless of where they are going for the day.</div>");
        }
    });
    jQuery("#field_7_12").click(function() {
        if (jQuery("#choice_7_12_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_7_12_5").remove();
            jQuery(".gchoice_7_12_5 ").after("<div class='alertmessage insidecheckbox gchoice_7_12_5'>It may not make sense to you that your loved one wants to wear dresses, but it might be important to them. You could suggest different types of dresses that might be more comfortable or easier to wear, if that is the concern. Or, the person might have a clear idea of the type of dress they want to wear and we should to try to honor that.</div>");
        }
    });
    jQuery("#field_7_13").click(function() {
        if (jQuery("#choice_7_13_1").is(":checked") && jQuery("#choice_7_13_2").is(":checked") && jQuery("#choice_7_13_3").is(":checked") && jQuery("#choice_7_13_4").is(":checked") && jQuery("#choice_7_13_5").is(":checked") && jQuery("#choice_7_13_6").is(":checked") && jQuery("#choice_7_13_7").is(":checked")) {
            jQuery("#field_7_13 .alertmessage").remove();
            jQuery("#field_7_13 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_7_13 .alertmessage").remove();
            jQuery("#field_7_13 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 these are all ways that communication can help you provide helpful dressing support.</div>");
        }
        if (!jQuery("#choice_7_13_1").is(":checked") && !jQuery("#choice_7_13_2").is(":checked") && !jQuery("#choice_7_13_3").is(":checked") && !jQuery("#choice_7_13_4").is(":checked") && !jQuery("#choice_7_13_5").is(":checked") && !jQuery("#choice_7_13_6").is(":checked") && !jQuery("#choice_7_13_7").is(":checked")) jQuery("#field_7_13 .alertmessage").remove();
    });
    jQuery("#field_7_15").click(function() {
        if (jQuery("#choice_7_15_1").is(":checked") && jQuery("#choice_7_15_2").is(":checked") && jQuery("#choice_7_15_3").is(":checked")) {
            jQuery("#field_7_15 .alertmessage").remove();
            jQuery("#field_7_15 .ginput_container_checkbox").after("<div class='alertmessage success'>Well done! You\u2019ve completed the lesson.</div>");
        } else {
            jQuery("#field_7_15 .alertmessage").remove();
            jQuery("#field_7_15 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more examples of being supportive.</div>");
        }
        if (jQuery("#choice_7_15_4").is(":checked")) {
            jQuery("#field_7_15 .alertmessage").remove();
            jQuery("#field_7_15 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (jQuery("#choice_7_15_5").is(":checked")) {
            jQuery("#field_7_15 .alertmessage").remove();
            jQuery("#field_7_15 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery("#choice_7_15_1").is(":checked") && !jQuery("#choice_7_15_2").is(":checked") && !jQuery("#choice_7_15_3").is(":checked") && !jQuery("#choice_7_15_4").is(":checked") && !jQuery("#choice_7_15_5").is(":checked")) jQuery("#field_7_15 .alertmessage").remove();
    });
    jQuery("#field_7_15").click(function() {
        if (jQuery("#choice_7_15_4").is(":checked")) {
            jQuery(".alertmessage.gchoice_7_15_4").remove();
            jQuery(".gchoice_7_15_4 ").after("<div class='alertmessage insidecheckbox gchoice_7_15_4'>Krista is assuming Darya does not want to get her clothes, and Darya might want to get her clothes even if it is difficult.</div>");
        }
    });
    jQuery("#field_7_15").click(function() {
        if (jQuery("#choice_7_15_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_7_15_5").remove();
            jQuery(".gchoice_7_15_5 ").after("<div class='alertmessage insidecheckbox gchoice_7_15_5'>Nico finds it easiest to dress when he is sitting on the bed so he can move around as needed and lie down to pull on his pants. Sitting in a chair does not work well for him. Gregor is not offering support in the way Nico needs \u2013 Gregor is trying to get things done to meet his own needs.</div>");
        }
    });
    jQuery("#field_7_16").click(function() {
        if (jQuery("#choice_7_16_1").is(":checked") && jQuery("#choice_7_16_2").is(":checked") && jQuery("#choice_7_16_3").is(":checked")) {
            jQuery("#field_7_16 .alertmessage").remove();
            jQuery("#field_7_16 .ginput_container_checkbox").after("<div class='alertmessage success'>Well done! You\u2019ve completed the lesson.</div>");
        } else {
            jQuery("#field_7_16 .alertmessage").remove();
            jQuery("#field_7_16 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more examples of honoring preferences or choices.</div>");
        }
        if (jQuery("#choice_7_16_4").is(":checked")) {
            jQuery("#field_7_16 .alertmessage").remove();
            jQuery("#field_7_16 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (jQuery("#choice_7_16_5").is(":checked")) {
            jQuery("#field_7_16 .alertmessage").remove();
            jQuery("#field_7_16 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (jQuery("#choice_7_16_5").is(":checked")) {
            jQuery("#field_7_16 .alertmessage").remove();
            jQuery("#field_7_16 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery("#choice_7_16_1").is(":checked") && !jQuery("#choice_7_16_2").is(":checked") && !jQuery("#choice_7_16_3").is(":checked") && !jQuery("#choice_7_16_4").is(":checked") && !jQuery("#choice_7_16_5").is(":checked") && !jQuery("#choice_7_16_6").is(":checked")) jQuery("#field_7_16 .alertmessage").remove();
    });
    jQuery("#field_7_16").click(function() {
        if (jQuery("#choice_7_16_4").is(":checked")) {
            jQuery(".alertmessage.gchoice_7_16_4").remove();
            jQuery(".gchoice_7_16_4 ").after("<div class='alertmessage insidecheckbox gchoice_7_16_4'>Gary is not asking Jose about his preference. Gary should not assume that Jose does not care about his appearance. In fact, before his accident, Jose loved dressing up and wearing stylish clothes.</div>");
        }
    });
    jQuery("#field_7_16").click(function() {
        if (jQuery("#choice_7_16_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_7_16_5").remove();
            jQuery(".gchoice_7_16_5 ").after("<div class='alertmessage insidecheckbox gchoice_7_16_5'>Maria is not considering that Jay likes buttoning his shirt and fastening his pants. It makes him feel like he is not having everything done for him. </div>");
        }
    });
    jQuery("#field_7_16").click(function() {
        if (jQuery("#choice_7_16_6").is(":checked")) {
            jQuery(".alertmessage.gchoice_7_16_6").remove();
            jQuery(".gchoice_7_16_6 ").after("<div class='alertmessage insidecheckbox gchoice_7_16_6'>Not only is Anna not honoring Christine\u2019s preferences, but she is preventing  Christine from doing her own dressing. Christine can zip up a sweater but when she wears a sweatshirt there is nothing for her to do \u2013 she cannot pull it over her head and there is nothing to zip. Christine loses the opportunity to be involved.</div>");
        }
    });
    /* Mobility Support */ jQuery("#field_8_14").click(function() {
        if (jQuery("#choice_8_14_1").is(":checked") && jQuery("#choice_8_14_2").is(":checked") && jQuery("#choice_8_14_3").is(":checked") && jQuery("#choice_8_14_4").is(":checked") && jQuery("#choice_8_14_5").is(":checked") && jQuery("#choice_8_14_6").is(":checked") && jQuery("#choice_8_14_7").is(":checked")) {
            jQuery("#field_8_14 .alertmessage").remove();
            jQuery("#field_8_14 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_8_14 .alertmessage").remove();
            jQuery("#field_8_14 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 All of these are a part of mobility.</div>");
        }
        if (!jQuery("#choice_8_14_1").is(":checked") && !jQuery("#choice_8_14_2").is(":checked") && !jQuery("#choice_8_14_3").is(":checked") && !jQuery("#choice_8_14_4").is(":checked") && !jQuery("#choice_8_14_5").is(":checked") && !jQuery("#choice_8_14_6").is(":checked") && !jQuery("#choice_8_14_7").is(":checked")) jQuery("#field_8_14 .alertmessage").remove();
    });
    jQuery("#field_8_11").click(function() {
        if (jQuery("#choice_8_11_1").is(":checked") && jQuery("#choice_8_11_2").is(":checked") && jQuery("#choice_8_11_3").is(":checked") && jQuery("#choice_8_11_4").is(":checked")) {
            jQuery("#field_8_11 .alertmessage").remove();
            jQuery("#field_8_11 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_8_11 .alertmessage").remove();
            jQuery("#field_8_11 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking - All of these are a part of mobility. It is important to understand your loved one\u2019s support needs and preferences related to mobility.</div>");
        }
        if (!jQuery("#choice_8_11_1").is(":checked") && !jQuery("#choice_8_11_2").is(":checked") && !jQuery("#choice_8_11_3").is(":checked") && !jQuery("#choice_8_11_4").is(":checked")) jQuery("#field_8_11 .alertmessage").remove();
    });
    jQuery("#field_8_16").click(function() {
        if (jQuery("#choice_8_16_1").is(":checked") && jQuery("#choice_8_16_2").is(":checked") && jQuery("#choice_8_16_3").is(":checked") && jQuery("#choice_8_16_4").is(":checked")) {
            jQuery("#field_8_16 .alertmessage").remove();
            jQuery("#field_8_16 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_8_16 .alertmessage").remove();
            jQuery("#field_8_16 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more mobility communication examples.</div>");
        }
        if (!jQuery("#choice_8_16_1").is(":checked") && !jQuery("#choice_8_16_2").is(":checked") && !jQuery("#choice_8_16_3").is(":checked") && !jQuery("#choice_8_16_4").is(":checked") && !jQuery("#choice_8_16_5").is(":checked")) jQuery("#field_8_16 .alertmessage").remove();
    });
    jQuery("#field_8_16").click(function() {
        if (jQuery("#choice_8_16_5").is(":checked")) {
            jQuery("#field_8_16 .alertmessage").remove();
            jQuery("#field_8_16 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_8_16").click(function() {
        if (jQuery("#choice_8_16_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_8_16_5").remove();
            jQuery(".gchoice_8_16_5").after("<div class='alertmessage insidecheckbox gchoice_8_16_5'>Communication is not telling a person what they need to do. It might be asking a person what they want, or paying attention to what a person needs through words or actions. Communication might be guiding a person to do something and supporting them to be in control.</div>");
        }
    });
    jQuery("#field_8_12").click(function() {
        if (jQuery("#choice_8_12_1").is(":checked") && jQuery("#choice_8_12_2").is(":checked") && jQuery("#choice_8_12_3").is(":checked")) {
            jQuery("#field_8_12 .alertmessage").remove();
            jQuery("#field_8_12 .ginput_container_checkbox").after("<div class='alertmessage success'>Well done! You\u2019ve completed the lesson.</div>");
        } else {
            jQuery("#field_8_12 .alertmessage").remove();
            jQuery("#field_8_12 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more ways Zoe is offering the right mobility support.</div>");
        }
        if (!jQuery("#choice_8_12_1").is(":checked") && !jQuery("#choice_8_12_2").is(":checked") && !jQuery("#choice_8_12_3").is(":checked") && !jQuery("#choice_8_12_4").is(":checked") && !jQuery("#choice_8_12_5").is(":checked")) jQuery("#field_8_12 .alertmessage").remove();
    });
    jQuery("#field_8_12").click(function() {
        if (jQuery("#choice_8_12_4").is(":checked") || jQuery("#choice_8_12_5").is(":checked")) {
            jQuery("#field_8_12 .alertmessage").remove();
            jQuery("#field_8_12 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_8_12").click(function() {
        if (jQuery("#choice_8_12_4").is(":checked")) {
            jQuery(".alertmessage.gchoice_8_12_4").remove();
            jQuery(".gchoice_8_12_4").after("<div class='alertmessage insidecheckbox gchoice_8_12_4'>This is not what makes Renee comfortable.</div>");
        }
        if (jQuery("#choice_8_12_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_8_12_5").remove();
            jQuery(".gchoice_8_12_5").after("<div class='alertmessage insidecheckbox gchoice_8_12_5'>This is not supportive because Renee can use her arms, legs and stand, with assistance.</div>");
        }
    });
    jQuery("#field_8_17").click(function() {
        if (jQuery("#choice_8_17_1").is(":checked") && jQuery("#choice_8_17_2").is(":checked") && jQuery("#choice_8_17_3").is(":checked")) {
            jQuery("#field_8_17 .alertmessage").remove();
            jQuery("#field_8_17 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_8_17 .alertmessage").remove();
            jQuery("#field_8_17 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 There are more things to keep in mind.</div>");
        }
        if (!jQuery("#choice_8_17_1").is(":checked") && !jQuery("#choice_8_17_2").is(":checked") && !jQuery("#choice_8_17_3").is(":checked")) jQuery("#field_8_17 .alertmessage").remove();
    });
    jQuery("#field_8_18").click(function() {
        if (jQuery("#choice_8_18_1").is(":checked") && jQuery("#choice_8_18_2").is(":checked") && jQuery("#choice_8_18_3").is(":checked") && jQuery("#choice_8_18_4").is(":checked") && jQuery("#choice_8_18_5").is(":checked") && jQuery("#choice_8_18_6").is(":checked")) {
            jQuery("#field_8_18 .alertmessage").remove();
            jQuery("#field_8_18 .ginput_container_checkbox").after("<div class='alertmessage success'>Well done! You\u2019ve completed the lesson. </div>");
        } else {
            jQuery("#field_8_18 .alertmessage").remove();
            jQuery("#field_8_18 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 More questions would help understand a person\u2019s mobility preferences.</div>");
        }
        if (!jQuery("#choice_8_18_1").is(":checked") && !jQuery("#choice_8_18_2").is(":checked") && !jQuery("#choice_8_18_3").is(":checked") && !jQuery("#choice_8_18_4").is(":checked") && !jQuery("#choice_8_18_5").is(":checked") && !jQuery("#choice_8_18_6").is(":checked")) jQuery("#field_8_18 .alertmessage").remove();
    });
    jQuery("#field_9_14").click(function() {
        if (jQuery("#choice_9_14_1").is(":checked") && jQuery("#choice_9_14_2").is(":checked") && jQuery("#choice_9_14_3").is(":checked") && jQuery("#choice_9_14_4").is(":checked") && jQuery("#choice_9_14_5").is(":checked") && jQuery("#choice_9_14_6").is(":checked") && jQuery("#choice_9_14_7").is(":checked")) {
            jQuery("#field_9_14 .alertmessage").remove();
            jQuery("#field_9_14 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_9_14 .alertmessage").remove();
            jQuery("#field_9_14 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 All of these are a part of continence support.</div>");
        }
        if (!jQuery("#choice_9_14_1").is(":checked") && !jQuery("#choice_9_14_2").is(":checked") && !jQuery("#choice_9_14_3").is(":checked") && !jQuery("#choice_9_14_4").is(":checked") && !jQuery("#choice_9_14_5").is(":checked") && !jQuery("#choice_9_14_6").is(":checked") && !jQuery("#choice_9_14_7").is(":checked")) jQuery("#field_9_14 .alertmessage").remove();
    });
    jQuery("#field_9_11").click(function() {
        if (jQuery("#choice_9_11_1").is(":checked") && jQuery("#choice_9_11_2").is(":checked") && jQuery("#choice_9_11_3").is(":checked") && jQuery("#choice_9_11_4").is(":checked")) {
            jQuery("#field_9_11 .alertmessage").remove();
            jQuery("#field_9_11 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_9_11 .alertmessage").remove();
            jQuery("#field_9_11 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more words you should use for an incontinence product.</div>");
        }
        if (jQuery("#choice_9_11_5").is(":checked")) {
            jQuery("#field_9_11 .alertmessage").remove();
            jQuery("#field_9_11 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery("#choice_9_11_1").is(":checked") && !jQuery("#choice_9_11_2").is(":checked") && !jQuery("#choice_9_11_3").is(":checked") && !jQuery("#choice_9_11_4").is(":checked") && !jQuery("#choice_9_11_5").is(":checked")) jQuery("#field_9_11 .alertmessage").remove();
    });
    jQuery("#field_9_11").click(function() {
        if (jQuery("#choice_9_11_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_9_11_5").remove();
            jQuery(".gchoice_9_11_5").after("<div class='alertmessage insidecheckbox gchoice_9_11_5'>When you use the word diaper for an adult it can take away your loved one\u2019s dignity and make them feel like they are being treated as a child.</div>");
        }
    });
    jQuery("#field_9_12").click(function() {
        if (jQuery("#choice_9_12_1").is(":checked") && jQuery("#choice_9_12_2").is(":checked") && jQuery("#choice_9_12_3").is(":checked") && jQuery("#choice_9_12_4").is(":checked") && jQuery("#choice_9_12_5").is(":checked")) {
            jQuery("#field_9_12 .alertmessage").remove();
            jQuery("#field_9_12 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_9_12 .alertmessage").remove();
            jQuery("#field_9_12 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking - All of these are important to maintain good health.</div>");
        }
        if (!jQuery("#choice_9_12_1").is(":checked") && !jQuery("#choice_9_12_2").is(":checked") && !jQuery("#choice_9_12_3").is(":checked") && !jQuery("#choice_9_12_4").is(":checked") && !jQuery("#choice_9_12_5").is(":checked")) jQuery("#field_9_12 .alertmessage").remove();
    });
    jQuery("#field_9_13").click(function() {
        if (jQuery("#choice_9_13_1").is(":checked") && jQuery("#choice_9_13_2").is(":checked") && jQuery("#choice_9_13_3").is(":checked") && jQuery("#choice_9_13_4").is(":checked") && jQuery("#choice_9_13_5").is(":checked")) {
            jQuery("#field_9_13 .alertmessage").remove();
            jQuery("#field_9_13 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_9_13 .alertmessage").remove();
            jQuery("#field_9_13 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 All of these are important to offering the right support.</div>");
        }
        if (!jQuery("#choice_9_13_1").is(":checked") && !jQuery("#choice_9_13_2").is(":checked") && !jQuery("#choice_9_13_3").is(":checked") && !jQuery("#choice_9_13_4").is(":checked") && !jQuery("#choice_9_13_5").is(":checked")) jQuery("#field_9_13 .alertmessage").remove();
    });
    jQuery("#field_9_15").click(function() {
        if (jQuery("#choice_9_15_1").is(":checked") && jQuery("#choice_9_15_2").is(":checked") && jQuery("#choice_9_15_3").is(":checked")) {
            jQuery("#field_9_15 .alertmessage").remove();
            jQuery("#field_9_15 .ginput_container_checkbox").after("<div class='alertmessage success'>Well done! You\u2019ve completed the lesson.</div>");
        } else {
            jQuery("#field_9_15 .alertmessage").remove();
            jQuery("#field_9_15 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking - All of these help to honor Karina\u2019s preferences.</div>");
        }
        if (!jQuery("#choice_9_15_1").is(":checked") && !jQuery("#choice_9_15_2").is(":checked") && !jQuery("#choice_9_15_3").is(":checked")) jQuery("#field_9_15 .alertmessage").remove();
    });
    jQuery("#field_9_16").click(function() {
        if (jQuery("#choice_9_16_1").is(":checked") && jQuery("#choice_9_16_2").is(":checked") && jQuery("#choice_9_16_3").is(":checked") && jQuery("#choice_9_16_4").is(":checked")) {
            jQuery("#field_9_16 .alertmessage").remove();
            jQuery("#field_9_16 .ginput_container_checkbox").after("<div class='alertmessage success'>Well done! You\u2019ve completed the lesson.</div>");
        } else {
            jQuery("#field_9_16 .alertmessage").remove();
            jQuery("#field_9_16 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 There are more examples of Jade providing Kathy the right support.</div>");
        }
        if (!jQuery("#choice_9_16_1").is(":checked") && !jQuery("#choice_9_16_2").is(":checked") && !jQuery("#choice_9_16_3").is(":checked") && !jQuery("#choice_9_16_4").is(":checked") && !jQuery("#choice_9_16_5").is(":checked") && !jQuery("#choice_9_16_6").is(":checked")) jQuery("#field_9_16 .alertmessage").remove();
    });
    jQuery("#field_9_16").click(function() {
        if (jQuery("#choice_9_16_5").is(":checked") || jQuery("#choice_9_16_6").is(":checked")) {
            jQuery("#field_9_16 .alertmessage").remove();
            jQuery("#field_9_16 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_9_16").click(function() {
        if (jQuery("#choice_9_16_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_9_16_5").remove();
            jQuery(".gchoice_9_16_5").after("<div class='alertmessage insidecheckbox gchoice_9_16_5'>Kathy does not want Jade to be in the bathroom with her the whole time. Kathy can do things on her own. Insisting on being in the bathroom with Kathy is not the type of support Kathy wants or needs.</div>");
        }
        if (jQuery("#choice_9_16_6").is(":checked")) {
            jQuery(".alertmessage.gchoice_9_16_6").remove();
            jQuery(".gchoice_9_16_6").after("<div class='alertmessage insidecheckbox gchoice_9_16_6'>Kathy has explained to Jade that she does not like all this stuff on the sink because she knocks things over and they either fall in the sink or on the floor and this stresses her out. This is not what Kathy wants and is making things more difficult for her.</div>");
        }
    });
    /*Restroom Support Quiz*/ jQuery("#field_10_14").click(function() {
        if (jQuery("#choice_10_14_1").is(":checked") && jQuery("#choice_10_14_2").is(":checked") && jQuery("#choice_10_14_3").is(":checked") && jQuery("#choice_10_14_4").is(":checked") && jQuery("#choice_10_14_5").is(":checked") && jQuery("#choice_10_14_6").is(":checked") && jQuery("#choice_10_14_7").is(":checked")) {
            jQuery("#field_10_14 .alertmessage").remove();
            jQuery("#field_10_14 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_10_14 .alertmessage").remove();
            jQuery("#field_10_14 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 All of these are a part of using the restroom.</div>");
        }
        if (!jQuery("#choice_10_14_1").is(":checked") && !jQuery("#choice_10_14_2").is(":checked") && !jQuery("#choice_10_14_3").is(":checked") && !jQuery("#choice_10_14_4").is(":checked") && !jQuery("#choice_10_14_5").is(":checked") && !jQuery("#choice_10_14_6").is(":checked") && !jQuery("#choice_10_14_7").is(":checked")) jQuery("#field_10_14 .alertmessage").remove();
    });
    jQuery("#field_10_11").click(function() {
        if (jQuery("#choice_10_11_1").is(":checked") && jQuery("#choice_10_11_2").is(":checked") && jQuery("#choice_10_11_3").is(":checked") && jQuery("#choice_10_11_4").is(":checked")) {
            jQuery("#field_10_11 .alertmessage").remove();
            jQuery("#field_10_11 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_10_11 .alertmessage").remove();
            jQuery("#field_10_11 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more ways you might help your loved one in the restroom.</div>");
        }
        if (!jQuery("#choice_10_11_1").is(":checked") && !jQuery("#choice_10_11_2").is(":checked") && !jQuery("#choice_10_11_3").is(":checked") && !jQuery("#choice_10_11_4").is(":checked") && !jQuery("#choice_10_11_5").is(":checked")) jQuery("#field_10_11 .alertmessage").remove();
    });
    jQuery("#field_10_11").click(function() {
        if (jQuery("#choice_10_11_5").is(":checked")) {
            jQuery("#field_10_11 .alertmessage").remove();
            jQuery("#field_10_11 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_10_11").click(function() {
        if (jQuery("#choice_10_11_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_10_11_5").remove();
            jQuery(".gchoice_10_11_5").after("<div class='alertmessage insidecheckbox gchoice_10_11_5'>Each situation is different, but it would not be offering support if we kept a person from using a toilet just because there might be some mess.</div>");
        }
    });
    jQuery("#field_10_12").click(function() {
        if (jQuery("#choice_10_12_1").is(":checked") && jQuery("#choice_10_12_2").is(":checked") && jQuery("#choice_10_12_3").is(":checked") && jQuery("#choice_10_12_4").is(":checked")) {
            jQuery("#field_10_12 .alertmessage").remove();
            jQuery("#field_10_12 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_10_12 .alertmessage").remove();
            jQuery("#field_10_12 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking - It\u2019s possible a person might not have specific preferences, but even asking about their preferences sends the message that you are giving them control.</div>");
        }
        if (!jQuery("#choice_10_12_1").is(":checked") && !jQuery("#choice_10_12_2").is(":checked") && !jQuery("#choice_10_12_3").is(":checked") && !jQuery("#choice_10_12_4").is(":checked")) jQuery("#field_10_12 .alertmessage").remove();
    });
    jQuery("#field_10_13").click(function() {
        if (jQuery("#choice_10_13_1").is(":checked") && jQuery("#choice_10_13_2").is(":checked") && jQuery("#choice_10_13_3").is(":checked") && jQuery("#choice_10_13_4").is(":checked")) {
            jQuery("#field_10_13 .alertmessage").remove();
            jQuery("#field_10_13 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_10_13 .alertmessage").remove();
            jQuery("#field_10_13 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more ways Anita can support Ginny.</div>");
        }
        if (!jQuery("#choice_10_13_1").is(":checked") && !jQuery("#choice_10_13_2").is(":checked") && !jQuery("#choice_10_13_3").is(":checked") && !jQuery("#choice_10_13_4").is(":checked") && !jQuery("#choice_10_13_5").is(":checked")) jQuery("#field_10_13 .alertmessage").remove();
    });
    jQuery("#field_10_13").click(function() {
        if (jQuery("#choice_10_13_5").is(":checked")) {
            jQuery("#field_10_13 .alertmessage").remove();
            jQuery("#field_10_13 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_10_13").click(function() {
        if (jQuery("#choice_10_13_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_10_13_5").remove();
            jQuery(".gchoice_10_13_5").after("<div class='alertmessage insidecheckbox gchoice_10_13_5'>It doesn\u2019t seem that Ginny is totally incontinent because she will use the toilet most of the time \u2013 she just seems to have sudden urges where she can\u2019t get to the bathroom on time or might not realize she has to go at that moment. It is important to still try to help her use the restroom so she can retain this ability for as long as possible.</div>");
        }
    });
    jQuery("#field_10_15").click(function() {
        if (jQuery("#choice_10_15_1").is(":checked") && jQuery("#choice_10_15_2").is(":checked") && jQuery("#choice_10_15_3").is(":checked") && jQuery("#choice_10_15_4").is(":checked")) {
            jQuery("#field_10_15 .alertmessage").remove();
            jQuery("#field_10_15 .ginput_container_checkbox").after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery("#field_10_15 .alertmessage").remove();
            jQuery("#field_10_15 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more things Ginger can do to support Connie.</div>");
        }
        if (!jQuery("#choice_10_15_1").is(":checked") && !jQuery("#choice_10_15_2").is(":checked") && !jQuery("#choice_10_15_3").is(":checked") && !jQuery("#choice_10_15_4").is(":checked") && !jQuery("#choice_10_15_5").is(":checked")) jQuery("#field_10_15 .alertmessage").remove();
    });
    jQuery("#field_10_15").click(function() {
        if (jQuery("#choice_10_15_5").is(":checked")) {
            jQuery("#field_10_15 .alertmessage").remove();
            jQuery("#field_10_15 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_10_15").click(function() {
        if (jQuery("#choice_10_15_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_10_15_5").remove();
            jQuery(".gchoice_10_15_5").after("<div class='alertmessage insidecheckbox gchoice_10_15_5'>Threatening Connie to take away something she likes if she is not doing something Ginger would like her to do is not a good approach. It doesn\u2019t solve the issue of why Connie might not want to use the restroom, and it can hurt the relationship. It also sends the message to Connie that she is not in charge, which is not supportive.</div>");
        }
    });
    jQuery("#field_10_16").click(function() {
        if (jQuery("#choice_10_16_1").is(":checked") && jQuery("#choice_10_16_2").is(":checked") && jQuery("#choice_10_16_3").is(":checked") && jQuery("#choice_10_16_4").is(":checked")) {
            jQuery("#field_10_16 .alertmessage").remove();
            jQuery("#field_10_16 .ginput_container_checkbox").after("<div class='alertmessage success'>Well done! You\u2019ve completed the lesson.</div>");
        } else {
            jQuery("#field_10_16 .alertmessage").remove();
            jQuery("#field_10_16 .ginput_container_checkbox").after("<div class='alertmessage keepclicking'>Keep clicking \u2013 there are more selections that show Tom\u2019s support for Alphie.</div>");
        }
        if (!jQuery("#choice_10_16_1").is(":checked") && !jQuery("#choice_10_16_2").is(":checked") && !jQuery("#choice_10_16_3").is(":checked") && !jQuery("#choice_10_16_4").is(":checked") && !jQuery("#choice_10_15_5").is(":checked")) jQuery("#field_10_16 .alertmessage").remove();
    });
    jQuery("#field_10_16").click(function() {
        if (jQuery("#choice_10_16_5").is(":checked")) {
            jQuery("#field_10_16 .alertmessage").remove();
            jQuery("#field_10_16 .ginput_container_checkbox").after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery("#field_10_16").click(function() {
        if (jQuery("#choice_10_16_5").is(":checked")) {
            jQuery(".alertmessage.gchoice_10_16_5").remove();
            jQuery(".gchoice_10_16_5").after("<div class='alertmessage insidecheckbox gchoice_10_16_5'>Alphie can still use the restroom, although he needs a lot of support to do so. As long as he can go to the restroom, Tom should support him to do this to help Alphie maintain continence as long as possible.</div>");
        }
    });
});
jQuery(document).ready(function() {
    jQuery(".cdp-card-array .px-5.py-4.space-y-2 .space-y-1 > a:contains('Workshop')").html("");
    jQuery(".cdp-card-array section .col-span-1 .font-black.text-base.text-red-accessible.mt-auto.px-5 a").text("Learn more");
    jQuery(".cdp-card-array section .col-span-1 .font-black.text-base.text-red-accessible.mt-auto.px-5").show();
    jQuery("#loadmore").on("click", function() {
        jQuery(".state-list .summerttext").removeClass("readmore");
        jQuery("#loadmore").attr("disabled", true);
    });
    jQuery("div.state-list .inner.paddingInner h2").click(function(e) {
        jQuery(this).parent().find(".textInner").slideToggle(function() {
            var property = jQuery(this).parent().find(".textInner").css("display");
            if (property == "block") var property = jQuery(this).parent().addClass("open");
            else var property = jQuery(this).parent().removeClass("open");
        });
    });
});



})();
//# sourceMappingURL=main.js.map
